import { DefaultSelect } from "ui";

import { SelectProps } from "antd";
import { filterOption } from "utils";

export const SearchSelect: React.FC<SelectProps> = (props) => {
  const { children } = props;
  return (
    <DefaultSelect {...props} filterOption={props.filterOption ?? filterOption} showSearch>
      {children}
    </DefaultSelect>
  );
};
